<div *ngIf="control?.invalid && control?.touched">
    <small *ngIf="control.hasError('required')" class="text-danger">*{{ getErrorMessage('required') }}<br></small>
    <small *ngIf="control.hasError('minlength')" class="text-danger">*{{ getErrorMessage('minlength') }}<br></small>
    <small *ngIf="control.hasError('maxlength')" class="text-danger">*{{ getErrorMessage('maxlength') }}<br></small>
    <small *ngIf="control.hasError('pattern')" class="text-danger">*{{ getErrorMessage('pattern') }}<br></small>
</div>
